<template>
  <div class="purchasing_dashboard">
    <div style="font-size: 22px; color: gray;padding:10px">Stock Level Zero</div>

    <div style="margin:10px">
      <v-row>


        <v-col cols="12">
          <v-card  elevation="12">
            <v-card-title  style="position: relative;">
              
              <v-row class="stock-zero-filter-row" no-gutters>

                <v-col cols="auto"><v-text-field label="Search..." variant="solo" density="compact" hide-details="true" @input="debouncedSearch($event)" style="width:250px;margin-left:5px;margin-right:10px"></v-text-field></v-col>

                <v-col cols="auto">
                  <v-select
                    
                    :items="['All','Pending PO','PO Confirmation Pending','Inquired on ETA','ETA Confirmed','Pending Tracking','Tracking Acquired','Delayed in Transit','Issue','Ignore','None']"

                    label="Status"
                    v-model="$store.state.stockZeroStatusFilter"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    style="width:175px;height:48px;margin-right:10px"
                  ></v-select> 
                </v-col>

                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stockZeroOnPoFilter" class="custom-checkbox" label="ON PO" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stockZeroNoPoFilter" class="custom-checkbox" label="NO PO" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stockZeroCustomerWaitingFiler" class="custom-checkbox" label="Customer Waiting" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stockZeroFollowUpDueFilter" class="custom-checkbox" label="Follow-Up Due" color="#ff7214" hide-details="true" density="compact" />
                </v-col>                                                                
              </v-row>     

            </v-card-title>

            <v-card-text>
              <Vue3EasyDataTable
                :headers="stock_zero_headers"
                :items="stock_zero_table_data"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="table_height"
                :search-value="search"
              >

              <template #item-follow_up_date_sortable="item">
                <div style='color:#ff7214;cursor:pointer;font-weight:bold' @click="setFollowUpDate(item)" v-if="item.follow_up_date_formatted">
                  {{item.follow_up_date_formatted}}
                </div>
                <v-btn v-if="!item.follow_up_date_formatted" style="background:#ff7214;color:white;height:15px;width:50px;font-size:8px;margin:5px 0px" @click="setFollowUpDate(item)">Set</v-btn>

              </template>

                <template #item-product="item">
                  <span v-if="item.item_db_key" class="dashboard-link" @click="openItemDetailPopup(item.po,item.item_db_key)">{{item.product}}</span>
                  <span v-if="!item.item_db_key" style="font-size:11px;font-weight:bold">{{item.product}}</span>
                  <div style="font-style:italic">{{item.description_full}}</div>
                </template>

                <template #item-total_qty_bo="item">
                  <div v-if="item.total_qty_bo > 0" style="line-height:100%;background:red;padding:2px;color:white;font-weight:bold;text-align:center;border-radius:4px;margin:5px 0">
                    <div style="font-size: 12px">{{item.total_qty_bo}}</div>
                    <div style="font-style: italic;">Customer Waiting</div>
                  </div>
                  <div v-if="item.total_qty_bo <= 0" style="padding:2px;text-align:center">{{item.total_qty_bo}}</div>
                </template>

                <template #item-po="item">
                  <div v-if="item.po === 'NO PO'" style="background:yellow;padding:2px;color:black;font-weight:bold;text-align:center;border-radius:4px;width:45px">{{item.po}}</div>
                  <div v-if="item.po === 'ONPO BUT NO OPEN QTY FOUND IN NEST'" style="">{{item.po}}</div>
                  <div v-if="item.po !== 'NO PO' && item.po !== 'ONPO BUT NO OPEN QTY FOUND IN NEST'" style="">
                    <span class="dashboard-link" @click="openPurchaseOrderDetailPopup(item.po)">{{item.po}}</span>
                  </div>
                </template>

                <template #item-vendor_name="item">
                  <router-link :to="{ name: 'vendor', params: {vendorpageid: item.vendor.page ? item.vendor.page : 'null'}}" target="_blank" class="dashboard-link">{{item.vendor.name}}</router-link>
                </template>

              <template #item-status_sortable="item">
                <div style="width:180px;padding:4px">
                  <v-select
                    :items="item.status === false ? ['Pending PO','PO Confirmation Pending','Inquired on ETA','ETA Confirmed','Pending Tracking','Tracking Acquired','Delayed in Transit','Issue','Ignore'] : ['Pending PO','PO Confirmation Pending','Inquired on ETA','ETA Confirmed','Pending Tracking','Tracking Acquired','Delayed in Transit','Issue','Ignore','None']"
                    label=""
                    :model-value="item.status === false ? null : item.status"
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    @update:modelValue="(value) => updateItemStatus(item, value)"
                  ></v-select>
                </div>
              </template>


                <template #item-po_date_sortable="item">
                  <div>{{item.po_date_formatted}}</div>
                </template>

                <template #item-first_upload_date_sortable="item">
                  {{item.first_upload_date_formatted}}
                </template>


                <template #item-eta_sortable="item">
                  <div>{{item.eta_formatted}}</div>
                </template>

                <template #item-eta_updated_cnt="item">
                  <div style="width:125px">{{item.eta_updated_cnt}}</div>
                  <div style="font-size: 9px; font-style: italic;" v-if="item.eta_last_updated_sortable.length > 2">Last Updated: {{item.eta_last_updated_formatted}}</div>
                </template>

                <template #item-any_po_received_sortable="item">
                  <div>{{item.any_po_received_formatted}}</div>
                </template>

                <template #item-tracking_info="item">
                  <div>{{item.shipping_company}}</div>
                  <div>{{item.tracking_number}}</div>
                </template>

                <template #item-substitutes="item">
                  <div v-if="item.substitute_1" style="width:125px">&bull;{{item.substitute_1}}</div>
                  <div v-if="item.substitute_2" style="width:125px">&bull;{{item.substitute_2}}</div>
                  <div v-if="item.substitute_3" style="width:125px">&bull;{{item.substitute_3}}</div>
                  <div v-if="item.substitute_4" style="width:125px">&bull;{{item.substitute_4}}</div>
                  <div v-if="item.substitute_5" style="width:125px">&bull;{{item.substitute_5}}</div>
                </template>                


                <template #item-sz_table_note="item">

                  <div v-for="n in item.sz_table_note" style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;min-width:100p">
                    <div style="font-style:italic">{{n.note}}</div>
                    <div style="font-size:10px;line-height:100%;color:gray;">submitted {{formatDate(n.submitted_date)}} by {{n.submitted_by}}</div>
                  </div>
                  
                  <v-btn style="background:#ff7214;color:white;height:15px;width:50px;font-size:8px;margin:5px 0px" @click="addStockZeroNote(item)">ADD NOTE</v-btn>
                  
                </template>

                <template #item-po_internal_notes="item">
                  <div v-for="n in item.po_internal_notes" style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;min-width:100p">
                    <div style="font-style:italic">{{n.note}}</div>
                    <div style="font-size:10px;line-height:100%;color:gray;">submitted {{formatDate(n.submitted_date)}} by {{n.submitted_by}}</div>
                  </div>
                </template>


                <template #item-po_item_internal_notes="item">
                  <div v-for="n in item.po_item_internal_notes" style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;min-width:100p">
                    <div style="font-style:italic">{{n.note}}</div>
                    <div style="font-size:10px;line-height:100%;color:gray;">submitted {{formatDate(n.submitted_date)}} by {{n.submitted_by}}</div>
                  </div>
                </template>
                
              </Vue3EasyDataTable>

              <v-card-actions>
                <!-- <div style="color:gray;font-size:10px">Record Count: {{stock_zero_table_data.length}}</div> -->
                <v-spacer></v-spacer>
                <v-btn style="background:#ff7214;color:white;height:15px;width:50px;font-size:8px;" @click="exportStockZero()" :disabled="stock_zero_table_data.length === 0">EXPORT</v-btn>                
              </v-card-actions>

            </v-card-text>
          </v-card>
        </v-col>
        
      </v-row>

    </div>

    <PurchaseOrderDetailPopUp v-if="po_detail" :po='po_for_component' @close="closePurchaseOrderDetailPopup()" />
    <ItemDetailPopUp v-if="item_detail" :po='po_for_component' :itemkey='item_for_component' @close="closeItemDetailPopup()" />
    

    <StockZeroFollowUpDatePopUp v-if="follow_up_item_for_component" @close="closeStockZeroFollowUpPopUp()" :itemkey='follow_up_item_for_component'/>
    
    <NoteStockZeroPopUp v-if="sz_note_key_for_component" @close="closeStockZeroNotePopUp()" :itemkey="sz_note_key_for_component"/>

  </div>
</template>

<script>
import firebase from 'firebase/compat/app';
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment-business-days'
import _ from 'lodash'
import ItemDetailPopUp from '@/components/ItemDetailPopUp.vue'
import PurchaseOrderDetailPopUp from '@/components/PurchaseOrderDetailPopUp.vue'
import NotePurchaseOrderPopUp from '@/components/NotePurchaseOrderPopUp.vue'
import NoteStockZeroPopUp from '@/components/NoteStockZeroPopUp.vue'
import StockZeroFollowUpDatePopUp from '@/components/StockZeroFollowUpDatePopUp.vue'

import Vue3EasyDataTable from 'vue3-easy-data-table';
import { emailMixin } from '../mixins/emailMixin.js'
import XLSX from 'xlsx'
import { poConfirmationFollowupEtaRequest } from '../mixins/poConfirmationFollowupEtaRequestMixin.js'
import { debounce } from 'lodash';

export default {
  name: 'PurchasingDashboard',
  components: {PurchaseOrderDetailPopUp,ItemDetailPopUp,Vue3EasyDataTable,NotePurchaseOrderPopUp,NoteStockZeroPopUp, StockZeroFollowUpDatePopUp},
  mixins: [emailMixin, poConfirmationFollowupEtaRequest],
  data(){
    return {
      tab: 'TO-DOS',
      po_detail: false,
      item_detail: false,
      po_for_component: null,
      item_for_component: null,
      stock_zero_note_popup: false,
      sz_key_for_component: null,
      sz_product_for_component: null,
      follow_up_item_for_component: null,
      sz_note_key_for_component: null,
      search: '',
      stock_zero_headers: [
        { text: "Qty BO", value: "total_qty_bo", sortable: true},
        { text: "Product", value: "product", sortable: true},
        { text: "PO Number", value: "po", sortable: true},
        { text: "PO Date", value: "po_date_sortable", sortable: true},

        { text: "PO Qty Open", value: "qty_open", sortable: true},

        { text: "Vendor", value: "vendor_name", sortable: true},
        { text: "ETA", value: "eta_sortable", sortable: true},
        { text: "Status", value: "status_sortable", sortable: true},
        { text: "Follow-Up Date", value: "follow_up_date_sortable", sortable: true },
        { text: "Table Notes", value: "sz_table_note", sortable: false},
        { text: "PO Internal Notes", value: "po_internal_notes", sortable: false},
        { text: "PO Item Internal Notes", value: "po_item_internal_notes", sortable: false},
        { text: "Tracking Info", value: "tracking_info", sortable: true},
        { text: "Stock Zero Date", value: "first_upload_date_sortable", sortable: true},
        { text: "Number of Open POs", value: "num_pos_with_product", sortable: true},
        { text: "ETA Updated Count", value: "eta_updated_cnt", sortable: true}
      ],
      table_height: 400,
    }
  },
  beforeMount(){
    if(this.user === 'vendor' || !this.user){
      this.$router.push('/')
    }
    this.table_height = 400
  },
  watch: {

  },
  created() {
    window.addEventListener("resize", this.sizeTable);
  },
  destroyed() {
    window.removeEventListener("resize", this.sizeTable);
  },
  computed: {
    ...mapGetters(['user','db','po_confirmation_status','stockZeroFollowUpDueFilter','stockZeroNoPoFilter','stockZeroOnPoFilter','stockZeroCustomerWaitingFiler', 'stockZeroStatusFilter']),
    stock_zero_table_data() {
      const stock_zero = JSON.parse(JSON.stringify(this.db.stock_zero));
      const purchase_orders = JSON.parse(JSON.stringify(this.db.purchase_orders));
      const items_for_po_search = {};
      const all_rows = [];

      for (let sz in stock_zero) {
        let item = stock_zero[sz];
        item.total_qty_bo = parseFloat(item.total_qty_bo);
        item.item_db_key = false;
        item.eta_raw = '';
        item.eta_last_updated_raw = '';
        item.any_po_received_raw = 'N/A';
        item.shipping_company = '';
        item.tracking_number = '';
        item.po_item_internal_notes = '';
        item.vendor = this.db.vendors['vendor_' + (item.primary_vendor || '').replace(/^0+/, '')];
        item.vendor_name = item.vendor.name;
        item.first_upload_date_sortable = item.first_upload_date;
        item.first_upload_date_formatted = this.formatDate(item.first_upload_date_sortable);
        const substitutes = [
          item.substitute_1, item.substitute_2, item.substitute_3,
          item.substitute_4, item.substitute_5
        ];
        item.substitutes_string = substitutes.filter(s => s && s.trim() !== '').join(', ');

        if (parseFloat(item.whse_1_onpo) > 0) {
          items_for_po_search[item.product] = {
            stock_zero_entry: item,
            stock_zero_id: sz,
            matching_pos: [],
            has_onpo: true
          };
        } else {
          item.po = 'NO PO';
          item.po_date_sortable = 0;
          item.po_date_formatted = '';
          item.num_pos_with_product = 0;
          item.eta_updated_cnt = 0;

          item.qty_open = 0

          // item.status = item.status ? item.status[item.unique_id] : false;
          item.status = item.status ? item.status[item.unique_id] : 'Pending PO';

          item.follow_up_date_sortable = item.follow_up_date?.[item.unique_id] ? Moment(item.follow_up_date?.[item.unique_id]).startOf('day').valueOf() : 0;
          item.follow_up_date_formatted = item.follow_up_date?.[item.unique_id] ? Moment(item.follow_up_date?.[item.unique_id]).format('MM/DD/YY') : '';

          item.sz_table_note = item.table_note ? item.table_note[item.unique_id] : []

          all_rows.push(item);
        }
      }

      for (let po in purchase_orders) {
        let po_info = purchase_orders[po];
        for (let item_id in po_info.items) {
          let item_info = po_info.items[item_id];
          let entry = items_for_po_search[item_info.product];
          if (entry) {
            entry.matching_pos.push({
              po_data: po_info,
              po_number: po_info.po_number,
              po_date_sortable: Moment(po_info.po_date).startOf('day').valueOf(),
              po_date_formatted: po_info.po_date,
              eta_raw: item_info.eta,
              eta_last_updated_raw: item_info.eta_last_provided,
              any_po_received_raw: item_info.last_receiving_date || 'NO',
              item_db_key: item_info.item_key,
              shipping_company: item_info.shipping_company,
              tracking_number: item_info.tracking_number,
              po_item_internal_notes: item_info.internal_notes,
              po_internal_notes: po_info.internal_notes,
              eta_updated_cnt: item_info.eta_history ? Object.keys(item_info.eta_history).length : 0,
              creative_key: po_info.po_number + ':::' +item_info.item_key,
              qty_open: item_info.qty_open ? parseFloat(item_info.qty_open) : 0
            });
          }
        }
      }

      for (let product in items_for_po_search) {
        let entry = items_for_po_search[product];
        let base = entry.stock_zero_entry;

        // if (entry.matching_pos.length > 0) {
        if (entry.matching_pos.filter(p => p.qty_open > 0).length > 0) { // adding '.lenght > 0' ensures that items that found an Open po but the qty open is 0 still appear in list 
          entry.matching_pos.forEach(po => {

            if (po.qty_open === 0) return;

            let row = JSON.parse(JSON.stringify(base));
            Object.assign(row, {
              po_data: po.po_data,
              po: po.po_number,
              eta_raw: po.eta_raw,
              eta_last_updated_raw: po.eta_last_updated_raw,
              any_po_received_raw: po.any_po_received_raw,
              item_db_key: po.item_db_key,
              shipping_company: po.shipping_company,
              tracking_number: po.tracking_number,
              po_item_internal_notes: po.po_item_internal_notes,
              po_internal_notes: po.po_internal_notes,
              po_date_sortable: po.po_date_sortable,
              po_date_formatted: po.po_date_formatted,
              eta_updated_cnt: po.eta_updated_cnt,
              num_pos_with_product: entry.matching_pos.filter(p => p.qty_open > 0).length,
              creative_key: po.creative_key,
              sz_table_note: row.table_note ? row.table_note[po.creative_key] : [],
              qty_open: po.qty_open
            });
            
            row.status = stock_zero[row.unique_id]?.status?.[row.creative_key] ?? false;

            row.follow_up_date_sortable = row.follow_up_date?.[row.creative_key] ? Moment(row.follow_up_date?.[row.creative_key]).startOf('day').valueOf() : 0;
            row.follow_up_date_formatted = row.follow_up_date?.[row.creative_key] ? Moment(row.follow_up_date?.[row.creative_key]).format('MM/DD/YY') : '';

            if(!row.status && this.po_confirmation_status(row.po_data) === 'Pending'){
              row.status = 'PO Confirmation Pending'

              const currentFollowUp = row.follow_up_date?.[row.creative_key];
              if (
                currentFollowUp === "" ||
                currentFollowUp === false ||
                typeof currentFollowUp === "undefined"
              ) {
                const twoDaysLater = Moment(row.po_date_sortable).add(2, 'days').startOf('day');
                row.follow_up_date_sortable = twoDaysLater.valueOf();
                row.follow_up_date_formatted = twoDaysLater.format('MM/DD/YY');
              }
            }

            all_rows.push(row);
          });
        } else {
          let row = JSON.parse(JSON.stringify(base));
          row.num_pos_with_product = 0
          row.po = entry.has_onpo ? 'ONPO BUT NO OPEN QTY FOUND IN NEST' : 'NO PO';

          row.qty_open = 0
          // row.status = row.status ? row.status[row.unique_id] : false
          if(row.status){
            if(row.status[row.unique_id]){
              row.status = row.status[row.unique_id]
            }else{
              row.status = false
            }
          }else{
            row.status = false
          }

          row.follow_up_date_sortable = 0
          row.follow_up_date_formatted = ''
          
          all_rows.push(row);
        }
      }

      // Format and filter once at the end
      const modules_data = all_rows
        .map(row => {

          row.status_sortable = row.status === false ? '' : row.status
          
          row.customer_waiting_search = row.total_qty_bo > 0 ? 'customer waiting' : ''

          row.po_internal_notes_flat = row.po_internal_notes
            ? Object.values(row.po_internal_notes)
                .map(n => `${n.note ?? ''} ${n.submitted_by ?? ''}`)
                .join(' ')
            : '';

          row.po_item_internal_notes_flat = row.po_item_internal_notes
            ? Object.values(row.po_item_internal_notes)
                .map(n => `${n.note ?? ''} ${n.submitted_by ?? ''}`)
                .join(' ')
            : '';

          let eta_string = (row.eta_raw || '').toString().trim();
          row.eta_sortable = Moment(eta_string, 'M/D/YY', true).isValid()
            ? '0-' + Moment(eta_string, 'M/D/YY').startOf('day').valueOf()
            : '1-' + eta_string.toUpperCase();
          row.eta_formatted = eta_string;

          let raw = row.eta_last_updated_raw;
          row.eta_last_updated_formatted = (typeof raw === 'number' && !isNaN(raw)) ? this.formatDate(raw) : '';
          row.eta_last_updated_sortable = (typeof raw === 'number' && !isNaN(raw)) ? '0-' + raw : '1-';

          let received = (row.any_po_received_raw || '').toString().trim();
          row.any_po_received_sortable = Moment(received, 'M/D/YY', true).isValid()
            ? '0-' + Moment(received, 'M/D/YY').startOf('day').valueOf()
            : '1-' + received.toUpperCase();
          row.any_po_received_formatted = received;

          row.tracking_info = row.shipping_company + ' ' + row.tracking_number;
          return row;
        })
        .filter(row => {
          const noPO = row.po === 'NO PO' || row.po === 'ONPO BUT NO OPEN QTY FOUND IN NEST';
          const custWaiting = row.total_qty_bo > 0;
          const status = row.status || '';

          const statusMatches =
            this.stockZeroStatusFilter === 'All' ||
            (this.stockZeroStatusFilter === 'None' && !status) ||
            this.stockZeroStatusFilter === status;

          const onPoMatches = this.stockZeroOnPoFilter ? !noPO : true;
          const noPoMatches = this.stockZeroNoPoFilter ? noPO : true;
          const custWaitingMatches = this.stockZeroCustomerWaitingFiler ? custWaiting : true;

          const today = Moment().endOf('day').valueOf();
          const followUpDateDue = row.follow_up_date_sortable > 0 && row.follow_up_date_sortable <= today;
          const followUpDueMatches = this.stockZeroFollowUpDueFilter ? followUpDateDue : true;

          return statusMatches && onPoMatches && noPoMatches && custWaitingMatches && followUpDueMatches;
        });


      return modules_data;
    }
  },
  methods: {
    debouncedSearch: debounce(function(event) {
      this.search = event.target._value.replace(/\*/g, "");
    }, 500),
    updateItemStatus(item,status){
      var self = this
      var valueToSet = (status === 'None') ? false : status;
      if(item.item_db_key){
        var status_key = item.po + ':::' + item.item_db_key
        firebase.database().ref('stock_zero').child(item.unique_id).child('status').child(status_key).set(valueToSet)
        firebase.database().ref('stock_zero').child(item.unique_id).child('status_log').push({user: self.user, timestamp: Date.now(), status: status, status_key: status_key})
      }else{
        firebase.database().ref('stock_zero').child(item.unique_id).child('status').child(item.unique_id).set(valueToSet)
        firebase.database().ref('stock_zero').child(item.unique_id).child('status_log').push({user: self.user, timestamp: Date.now(), status: status, status_key: item.unique_id})
      }
      
    },
    setFollowUpDate(item){
      var key = null
      if(item.item_db_key){
        key = item.po + ':::' + item.item_db_key
      }else{
        key = item.unique_id
      }
      this.follow_up_item_for_component = {stock_zero_id: item.unique_id, po_item_key: key}
    },
    closeStockZeroFollowUpPopUp(){
      this.follow_up_item_for_component = null
    },
    closeStockZeroNotePopUp(){
      this.sz_note_key_for_component = null
    },
    exportStockZero(){

        var items = this.stock_zero_table_data
        var export_arr = []

        for(var i = 0; i < items.length; i++){
          var item = items[i]
          var row_item = {
            'Qty BO': item.total_qty_bo,
            'Product': item.product,
            'Description': item.description_full,
            'PO Number': item.po,
            'PO Date': item.po_date_formatted,

            'PO Qty Open': item.qty_open,

            'Vendor': item.vendor_name,
            'ETA': item.eta_formatted,
            'Status': item.status_sortable,
            'Follow-Up Date': item.follow_up_date_formatted,
            'Table Notes': '',
            'PO Internal Notes': '',
            'PO Item Internal Notes': '',
            'Tracking Info': item.tracking_info,
            'Stock Zero Date': item.first_upload_date_formatted,
            'Number of Open POs': item.num_pos_with_product,
            'ETA Updated Count': item.eta_updated_cnt,
          }

          for(var n in item.sz_table_note){
            row_item['Table Notes'] += item.sz_table_note[n].note + ' (' + item.sz_table_note[n].submitted_by + ' on ' + this.formatDate(n.submitted_date) + '), '
          }

          for(var n in item.po_internal_notes){
            row_item['PO Internal Notes'] += item.po_internal_notes[n].note + ' (' + item.po_internal_notes[n].submitted_by + ' on ' + this.formatDate(n.submitted_date) + '), '
          }

          for(var n in item.po_item_internal_notes){
            row_item['PO Item Internal Notes'] += item.po_item_internal_notes[n].note + ' (' + item.po_item_internal_notes[n].submitted_by + ' on ' + this.formatDate(n.submitted_date) + '), '
          }

          export_arr.push(row_item)
        }

        var wscols = [
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:30},
            {wch:100},
            {wch:100},
            {wch:30}
        ];

        var worksheet = XLSX.utils.json_to_sheet(export_arr)
        worksheet['!cols'] = wscols;
        var workbook = XLSX.utils.book_new()
        var export_date = Date.now()
        XLSX.utils.book_append_sheet(workbook, worksheet)
        XLSX.writeFile(workbook, 'Stock Zero Items ' + export_date + '.xlsx')        
    }, 
    sizeTable(){
      var wh = window.innerHeight;
      this.table_height = wh - 275
    },
    addStockZeroNote(item){      
      var key = null
      if(item.item_db_key){
        key = item.po + ':::' + item.item_db_key
      }else{
        key = item.unique_id
      }

      this.sz_note_key_for_component = {stock_zero_id: item.unique_id, po_item_key: key}
    },
    openPurchaseOrderDetailPopup(po){
      this.po_for_component = po
      this.po_detail = true
    },
    closePurchaseOrderDetailPopup(){
      this.po_for_component = null
      this.po_detail = false
    },
    openItemDetailPopup(po,item){
      this.po_for_component = po
      this.item_for_component = item
      this.item_detail = true
    },
    closeItemDetailPopup(){
      this.po_for_component = null
      this.item_for_component = null
      this.item_detail = false
    },
    formatDate(date){
      return Moment(date).format('MM/DD/YY')
    },
    formatDateTime(date){
      return Moment(date).format('MM/DD/YY hh:mma')
    }
  }
}
</script>

<style scoped>

  .v-card .v-card-title{
    color: gray;
    font-size: 14px;
  }

  .v-card .v-card-text {
    line-height: 100%;
  }

  .table-container{
    position: relative;
    top: 5px;
    margin:0px 20px;
  }

  .flagged{
    width: 20px;
    height: 20px;
    border:1px solid #ff7214;
    background: #ff7214;
    cursor: pointer;
  }

  .unflagged{
    width: 20px;
    height: 20px;
    border:1px solid #ff7214;
    cursor: pointer;
  }

  .needs_attention{
    background: red;
    color: white;
    width: 15px;
    height: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 140%;
    font-weight: bold;
    border-radius: 100%;
  }

  a{
    text-decoration: none;
  }

  .v-card-actions{
    min-height: 0px;
    padding: 4px 0px;
  }

  .dashboard-link{
    color:#ff7214;
    cursor:pointer;
    font-weight: bold;
    font-size: 11px;
    /*text-decoration: underline;*/

  }

  .stock-zero-filter-row {
    position: relative;
    left:-5px;
    color: black;
    padding-bottom: 22px;
  }

  .stock-zero-filter-row .v-col {
    height:20px;
  }

  >>>.custom-checkbox .v-label {
    font-size: 0.8rem;
    padding-right:20px;
  }

  >>>.v-select__selection-text{
    font-size: 12px;
    font-weight: bold;
    padding-top:3px;
  }
</style>
